import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import Toast, { POSITION } from "vue-toastification";
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import store from "./state/store";

import BootstrapVue3 from 'bootstrap-vue-3';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import Maska from 'maska';

import VueFeather from 'vue-feather';

import '@/assets/scss/config/material/app.scss';
import '@vueform/slider/themes/default.css';
import '@/assets/scss/mermaid.min.css';


// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();


// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);



AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

createApp(App)
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVue3)
    .component(VueFeather.type, VueFeather)
    .use(Maska)
    .use(i18n)
    .use(Toast, {
        position: POSITION.TOP_RIGHT,
        rtl: true
    })
    .use(Vue3PersianDatetimePicker, {
        name: 'CustomDatePicker',
        props: {
            format: 'YYYY-MM-DD',
            displayFormat: 'jYYYY-jMM-jDD',
            editable: true,
            inputClass: 'form-control my-custom-class-name',
            placeholder: 'تاریخ',
            altFormat: 'YYYY-MM-DD',
            autoSubmit: false,
            clearable: true,
            //...
            //... And whatever you want to set as default.
            //...
        }
    })
    .use(vClickOutside).mount('#app');